<template>
  <div class="guide-pop">
    <van-popup v-model="show" :close-on-click-overlay="false" :round="true" :closeable="isTips" @close="close" get-container="body">
      <div class="content">
        <div class="title">入网签约提醒</div>
        <!-- <div class="text">{{tipsText}}</div> -->
        <div class="text">根据国家支付相关法律法规，平台与商家直接不可直接使用同一支付主体，商家需入网签约商户号才可继续使用。</div>
        <div class="btn-box">
          <!-- <div class="btn-item" @click="close">稍后再说</div>
          <div class="btn-item active" v-if="jjInfo.config === false" @click="config">去配置</div>
          <div class="btn-item active" v-else @click="apply">去申请</div> -->
          <div class="btn-item active" @click="apply">去申请</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { domainName } from '@/utils/constant'
export default {
  data() {
    return {
      show: false,
      isTips: true,
      jjInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide'
    ]),
    tipsText() {
      const { config,isJperson,state } = this.jjInfo
      if (config === false) {
        return '根据国家支付相关法律法规，平台与商家直接不可直接使用同一支付主体，商家需入网签约商户号才可继续使用。申请入网先配置“入网签约人。”'
      } else if (isJperson == false && config == null) {
        return '根据国家支付相关法律法规，平台与商家直接不可直接使用同一支付主体，商家需入网签约商户号才可继续使用。'
      } else if (isJperson == true) {
        if (state == '05') {
          return '您申请的入网签约对公账户验资未成功，请及时处理。'
        } if (state == '04') {
          return '您申请的入网签约未通过审核，请及时处理'
        }
      }
    },
  },
  
  mounted() {
    this.getFindJJInfo()
  },
  methods: {
    getFindJJInfo() {
      this.$api.common.findJJInfo()
        .then(res => {
          if (res.success) {
            this.jjInfo = res.data
            // 是否进件人或是经销商并且未配置进件人
            // if (res.data.isJperson || res.data.config === 'false') {
            //   this.show = true
            // }
            if (res.data.isJperson && res.data.state != '03') {
              // this.show = true
            }
            this.$store.commit('setJjInfo', res.data)
          }
          
        })
    },
    close() {
      this.show = false
    },
    apply() {
      const { accesserId="001",accesserUserId ='002',url ='url' } = this.jjInfo
      window.open(`${domainName}?accesser_id=${accesserId}&accesser_user_id=${accesserUserId}&h5UserId=${this.userInfo.id}&url=${url}`)
      this.isTips = false
    },
    config() {
      this.$router.push({path: '/account'})
    },
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    width: 300px;
    padding: 20px;
    background: #FFFFFF;
    box-sizing: border-box;
    .title {
      font-size: 17px;
      color: #333333;
      font-weight: bold;
      text-align: center;
    }
    .text {
      color: #333333;
      font-size: 15px;
      font-weight: 400;
      line-height: 29px;
      margin-top: 15px;
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      .btn-item {
        flex:1;
        height: 44px;
        font-size: 17px;
        text-align: center;
        line-height: 44px;
        background: #E5E5E5;
        border-radius: 4px;
        font-weight: 500;
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
      .active {
        color: #fff;
        background: linear-gradient(180deg, #FF8820 0%, #FF6B31 100%);
      }
    }
  }
</style>